import { HarvestReportFormGroup } from './harvest-report-form-group';
import { LoadingWrapperService } from '../../shared/services/loading-wrapper.service';
import { AlertService } from '../../shared/services/alert.service';
import { ReportingService } from '../services/reporting.service';
import { FileSaverService } from '../../shared/services/file-saver.service';
import { AlphabeticalNamedSorter } from '../../shared/sort-methods';
import { finalize } from 'rxjs/operators';
var HarvestReportFormComponent = /** @class */ (function () {
    function HarvestReportFormComponent(options, loadingService, alertService, reportingService, reportWriterService) {
        var _this = this;
        this.loadingService = loadingService;
        this.alertService = alertService;
        this.reportingService = reportingService;
        this.reportWriterService = reportWriterService;
        this.crops = [];
        this.rootForm = new HarvestReportFormGroup();
        options.crops.subscribe(function (c) { return _this.crops = c.sort(AlphabeticalNamedSorter); });
    }
    Object.defineProperty(HarvestReportFormComponent.prototype, "startDateFormControl", {
        get: function () {
            return this.rootForm.startDateFormControl;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HarvestReportFormComponent.prototype, "endDateFormControl", {
        get: function () {
            return this.rootForm.endDateFormControl;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HarvestReportFormComponent.prototype, "cropFormControl", {
        get: function () {
            return this.rootForm.cropFormControl;
        },
        enumerable: true,
        configurable: true
    });
    HarvestReportFormComponent.prototype.ngOnInit = function () {
    };
    HarvestReportFormComponent.prototype.generateReport = function () {
        var _this = this;
        this.loadingService.setMessage('Generating harvest report...');
        this.reportingService.getHarvestReport({
            cropId: this.cropFormControl.value,
            endDate: this.endDateFormControl.value,
            startDate: this.startDateFormControl.value
        })
            .pipe(finalize(function () { return _this.loadingService.clearMessage(); }))
            .subscribe(function (file) { return _this.reportWriterService.save(file); }, function (error) { return _this.alertService.error('Error generating harvest report.'); });
    };
    return HarvestReportFormComponent;
}());
export { HarvestReportFormComponent };



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/reporting/harvest-report-form/harvest-report-form.component.ts.pre-build-optimizer.js